<template>
  <main class="grey-layout md:py-8 justify-center justify-items-center text-center text-black">
    <p class="text-xl">
        Submit Personal KYC digitally
        <br /><span class="grid text-base">केवाईसी डिजिटली भरें</span>
    </p>
    <!-- KYC Animation -->
    <Vue3Lottie :animationData="KYCAnimation" :speed="1" :loop="false" />
    <!-- <img
      src="../assets/kyc-selection.png"
      alt="KYC Selection"
      width="150"
      height="150"
      class="w-32 md:w-40 pt-4"
    /> -->
    <p class="text-base">
      Digital KYC is easy & fast
      <br />
      <span class="text-sm">डिजिटल केवाईसी आसान और तेज है</span>
    </p>
    <!-- <div class="flex justify-center items-center">
      <hr class="w-32 border-gray-300 mr-4" />
        <span class="mr-4 text-xs">Or</span>
      <hr class="w-32 border-gray-300" />
    </div> -->
    <!-- e-aadhaarNumber  -->
    <section v-if="flagsData?.digilocker">
      <div class="text-justify" v-if="flagsData?.digilocker.toLowerCase() === 'karza_eadhaar'">
          <p class="text-base font-semibold mt-4">
            Enter Aadhaar Number
          </p>
          <p class="text-xs font-normal">
            *You will receive an OTP on the number linked with your Aadhaar
          </p>
        <div class="label mt-4">
          <form
            @submit.prevent="sendOtp"
            class="grid relative"
            @input="updateAadhaarInput"
            @keyup.delete="handleDeletion"
            @paste="handlePaste"
            ref="form"
          >
          <section class="grid grid-cols-3 md:gap-3">
            <div
              class="grid mt-4 md:mt-3 grid-cols-4 max-w-xs justify-items-center justify-center justify-self-center"
            >
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_1"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[0]"
                required
                name="1"
                minlength="1"
                maxlength="1"
                tabindex="1"
                @keypress="aadhaarFirstLetterValidation"
                @click="CheckValueFocus(1)"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_2"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[1]"
                required
                name="2"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                @click="CheckValueFocus(2)"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_3"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[2]"
                required
                name="3"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                @click="CheckValueFocus(3)"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_4"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[3]"
                required
                name="4"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                @click="CheckValueFocus(4)"
                :disabled="disableOtPAfterSubmit"
              />
            </div>
            <div
              class="grid mt-4 md:mt-3 grid-cols-4 max-w-xs justify-items-center justify-center justify-self-center"
            >
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_1"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[4]"
                required
                name="5"
                minlength="1"
                maxlength="1"
                tabindex="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_2"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[5]"
                required
                name="6"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_3"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[6]"
                required
                name="7"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_4"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[7]"
                required
                name="8"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
            </div>
             <div
              class="grid mt-4 md:mt-3 grid-cols-4 max-w-xs justify-items-center justify-center justify-self-center"
            >
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_1"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[8]"
                required
                name="9"
                minlength="1"
                maxlength="1"
                tabindex="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_2"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[9]"
                required
                name="10"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_3"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[10]"
                required
                name="11"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="aadharInput aadharInput--single inputAadharCss_4"
                inputmode="numeric"
                v-model.trim="params.aadhaarNo[11]"
                required
                name="12"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
            </div>
          </section>
            <!-- <input
              type="text"
              inputmode="numeric"
              name="aadhaarNumber"
              id="aadhaarNumber"
              class="input"
              placeholder="Enter Aadhaar Number"
              maxlength="12"
              minlength="12"
              required
              v-model="this.params.aadhaarNo"
              @keypress="isNumber"
              @input="updateAadhaarInput"
            /> -->
            <custom-button
              v-if="OtpSendSuccess"
              variant="primary"
              class="my-8 md:mb-0 justify-center font-semibold text-base"
              type="submit"
              :loading="loading"
            >Send OTP</custom-button>
          </form>
          <form
            v-if="!OtpSendSuccess"
            class="grid relative"
            @submit.prevent="submitOtp"
            @paste="handlePaste"
            @input="handleInput"
            @keyup.delete="handleDeletionOtp"
            ref="form"
          >
            <h1 class="text-base font-semibold mt-4">Enter OTP</h1>
            <div
              :class="statusSuccess ? 'grid gap-4 mt-3 grid-cols-7 justify-items-center justify-center justify-self-start' :
                'grid gap-4 mt-3 grid-cols-6 max-w-xs justify-items-center justify-center justify-self-start'"
            >
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[0]"
                required
                name="1"
                minlength="1"
                maxlength="1"
                autofocus
                tabindex="1"
                ref="del"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[1]"
                required
                name="2"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[2]"
                required
                name="3"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[3]"
                required
                name="4"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[4]"
                required
                name="5"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <input
                type="text"
                class="input input--single"
                inputmode="numeric"
                v-model.trim="otp[5]"
                required
                name="6"
                minlength="1"
                maxlength="1"
                @keypress="isNumber"
                :disabled="disableOtPAfterSubmit"
              />
              <div v-if="statusSuccess">
                <img src="../assets/sucessTick.svg" alt="" class="w-9 h-9"/>
              </div>
            </div>
            <span class="max-w-xs mt-2 text-gray-600 text-xs w-96">
              <span v-if="!timer">
                <button
                  v-if="resendOtpEnable"
                  id="resend-button"
                  class="text-primary"
                  type="button"
                  @click="resendOtp"
                >Resend OTP</button>
                 <button
                  v-else
                  id="resend-button"
                  class="cursor-default text-gray-400"
                  type="button"
                >Resend OTP</button>
              </span>
              <template v-else>
                <span>Resend OTP in</span>&nbsp;
                <span class="text-primary">{{ timer }}s</span>
              </template>
            </span>
            <p class="text-errorColor text-xs mt-4" v-if="errorMessage">{{ errorMessage }}</p>
            <custom-button
              variant="primary"
              class="my-8 md:mb-0 justify-center font-semibold text-base"
              type="submit"
              :loading="loading"
              :disabled="submitOtpEnable"
            >Continue</custom-button>
          </form>
        </div>
      </div>
      <section v-else class="grid text-center md:mt-12">
          <router-link
            v-if="this.flagsData.manualKycEnabled && !$route.query.mode"
            :to="{ name: 'Pre Approval Step 2' }"
            class="border-primary underline p-5 rounded items-center text-primary gap-4"
          >
            <p class="grid text-xs">
              Any Other Option / कोई अन्य विकल्प
            </p>
          </router-link>
          <custom-button
            variant="primary"
            :loading="loading"
            @click="getDigilockerUrl"
            class="md:w-80 paddingBtn"
          >
            <p class="grid text-base">
              Start Digital KYC / स्टार्ट डिजिटल केवाईसी
            </p>
          </custom-button>
      </section>
    </section>
    <section v-else class="grid text-center md:mt-10">
      <router-link
        v-if="this.flagsData.manualKycEnabled && !$route.query.mode"
        :to="{ name: 'Pre Approval Step 2' }"
        class="border-primary underline p-5 rounded items-center text-primary gap-4"
      >
        <p class="grid text-xs">
          Any Other Option / कोई अन्य विकल्प
        </p>
      </router-link>
      <custom-button
        variant="primary"
        :loading="loading"
        @click="getDigilockerUrl"
        class="md:w-80 paddingBtn text-base"
      >
        <p class="grid text-base">
          Start Digital KYC / स्टार्ट डिजिटल केवाईसी
        </p>
      </custom-button>
    </section>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomButton from '../components/CustomButton.vue';
import KYCAnimation from '../assets/animation/Digital-KYC-Animation.json';

export default {
  name: 'KycSelection',
  components: {
    CustomButton,
  },
  computed: {
    ...mapGetters(['flagsData', 'skipBusinessProfileInReferral', 'applicationId', 'videoVerified', 'reKycStatus', 'flagsAllData', 'reKyc']),
  },
  data() {
    return {
      loading: undefined,
      otp: [],
      timer: 120,
      OtpSendSuccess: true,
      timerInterval: undefined,
      errorMessage: undefined,
      enableSendOtp: true,
      statusSuccess: false,
      resendOtpEnable: true,
      submitOtpEnable: false,
      disableOtPAfterSubmit: false,
      KYCAnimation,
      params: {
        aadhaarNo: [],
      }
    };
  },
  methods: {
    getDigilockerUrl() {
      this.$trackEvent(this.$mixpanelEvent.START_DIGITAL_KYC);
      this.loading = true;
      this.$store.dispatch('signzyDigilockerUrl', {
        urlParams: {
          statusChangeRequired: this.$route.query.mode === 'verify-digiLocker' || this.reKycStatus ? false : undefined,
          reKycFlag: this.reKyc,
        },
      }).then((result) => {
        if (result?.url) {
          this.loading = false;
          window.location = result.url;
        }
      })
      .catch(() => {
          this.loading = false;
        });
    },
    sendOtp() {
      const FormData = document.getElementsByTagName("input");
      FormData[11].blur();
      this.loading = true;
      const params = {
        aadhaarNo: this.params.aadhaarNo.join(""),
      };
      this.$store
      .dispatch('digiLockerKarzaOtp', params)
      .then(() => {
        this.loading = false;
        this.OtpSendSuccess = false;
        this.timer = 120;
        this.startTimer();
        const FormElement = document.getElementsByTagName("input");
        FormElement[12].focus();
      })
      .catch((err) => {
        if (err.message === 'EPL-10000') {
          this.$router.push({ name: 'Pre Approval Step 2' });
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    CheckValueFocus(num) {
      const FormElement = document.getElementsByTagName("input");
      if ((num === 2 && FormElement[1].value === '' && FormElement[0].value === '') ||
          (num === 3 && FormElement[2].value === '' && FormElement[0].value === '') ||
          (num === 4 && FormElement[3].value === '' && FormElement[0].value === '')) {
        FormElement[0].focus();
      }
    },
    aadhaarFirstLetterValidation(evt) {
       const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 50 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    handleDeletionOtp(e) {
      const FormElement = document.getElementsByTagName("input");
      const inputName = e.target.name;
      if (inputName === '2' && FormElement[12].value) {
        if (FormElement[13].value) {
          FormElement[13].focus();
        } else {
          FormElement[12].focus();
        }
      } else if (inputName === '3' && FormElement[13].value) {
        if (FormElement[14].value) {
          FormElement[14].focus();
        } else {
          FormElement[13].focus();
        }
      } else if (inputName === '4' && FormElement[14].value) {
        if (FormElement[15].value) {
          FormElement[15].focus();
        } else {
          FormElement[14].focus();
        }
      } else if (inputName === '5' && FormElement[15].value) {
        if (FormElement[16].value) {
          FormElement[16].focus();
        } else {
          FormElement[15].focus();
        }
      } else if (inputName === '6' && FormElement[16].value) {
        if (FormElement[17].value) {
          FormElement[17].focus();
        } else {
          FormElement[16].focus();
        }
      }
    },
    handleDeletion(e) {
      const FormElement = document.getElementsByTagName("input");
      const inputName = e.target.name;
      if (inputName === '2' && FormElement[0].value) {
        if (FormElement[1].value) {
          FormElement[1].focus();
        } else {
          FormElement[0].focus();
        }
      } else if (inputName === '3' && FormElement[1].value) {
        if (FormElement[2].value) {
          FormElement[2].focus();
        } else {
          FormElement[1].focus();
        }
      } else if (inputName === '4' && FormElement[2].value) {
        if (FormElement[3].value) {
          FormElement[3].focus();
        } else {
          FormElement[2].focus();
        }
      } else if (inputName === '5' && FormElement[3].value) {
        if (FormElement[4].value) {
          FormElement[4].focus();
        } else {
          FormElement[3].focus();
        }
      } else if (inputName === '6' && FormElement[4].value) {
        if (FormElement[5].value) {
          FormElement[5].focus();
        } else {
          FormElement[4].focus();
        }
      } else if (inputName === '7' && FormElement[5].value) {
        if (FormElement[6].value) {
          FormElement[6].focus();
        } else {
          FormElement[5].focus();
        }
      } else if (inputName === '8' && FormElement[6].value) {
        if (FormElement[7].value) {
          FormElement[7].focus();
        } else {
          FormElement[6].focus();
        }
      } else if (inputName === '9' && FormElement[7].value) {
        if (FormElement[8].value) {
          FormElement[8].focus();
        } else {
          FormElement[7].focus();
        }
      } else if (inputName === '10' && FormElement[8].value) {
        if (FormElement[9].value) {
          FormElement[9].focus();
        } else {
          FormElement[8].focus();
        }
      } else if (inputName === '11' && FormElement[9].value) {
        if (FormElement[10].value) {
          FormElement[10].focus();
        } else {
          FormElement[9].focus();
        }
      } else if (inputName === '12' && FormElement[10].value) {
        if (FormElement[11].value) {
          FormElement[11].focus();
        } else {
          FormElement[10].focus();
        }
      }
    },
    updateAadhaarInput(e) {
      const input = e.target;
      const FormElement = document.getElementsByTagName("input");
      const inputName = e.target.name;
      if (input.nextElementSibling && input.value) {
        input.nextElementSibling.focus();
      } else if (input.previousElementSibling && !input.value) {
        input.previousElementSibling.focus();
      } else if (inputName === '4' && input.value) {
        FormElement[4].focus();
      } else if (inputName === '8' && input.value) {
        FormElement[8].focus();
      } else if (inputName === '5' && input.value === "") {
        FormElement[3].focus();
      } else if (inputName === '9' && input.value === "") {
        FormElement[7].focus();
      }
    },
    handleInput(e) {
      const input = e.target;
      if (input.nextElementSibling && input.value.length) {
        input.nextElementSibling.focus();
      } else if (input.previousElementSibling && !input.value) {
        input.previousElementSibling.focus();
      }
    },
    handlePaste(e) {
      const paste = e.clipboardData.getData("text");
      const { form } = this.$refs;
      const inputs = form.querySelectorAll(".input");
      inputs.forEach((input, i) => {
        input.value = paste[i] || "";
      });
    },
    resendOtp() {
      this.submitOtpEnable = true;
      this.errorMessage = "";
      if (this.params.aadhaarNo.join("").length === 12) {
        this.timer = 120;
        this.startTimer();
      }
      const params = {
        aadhaarNo: this.params.aadhaarNo.join(""),
      };
      this.$store
        .dispatch("digiLockerKarzaOtp", params)
        .then(() => {
          this.OtpSendSuccess = false;
          this.submitOtpEnable = false;
        })
        .catch(() => {
          this.submitOtpEnable = true;
         });
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    submitOtp() {
      this.errorMessage = "";
      this.disableOtPAfterSubmit = true;
      this.loading = true;
      this.resendOtpEnable = false;
      const params = {
        aadhaarNo: this.params.aadhaarNo.join(""),
        otp: this.otp.join(""),
      };
      this.$store
        .dispatch("v2digiLockerKarzaVerifyOtp", params)
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            this.statusSuccess = true;
            if (response.data.subStatus === "personalInfoUpdated") {
              if (this.flagsAllData?.currentAddressRequired) {
                this.$router.push({
                  name: 'Personal Address',
                });
              } else if (this.flagsData.faceVerificationEnabled && !this.videoVerified) {
                this.$router.push({
                  name: 'Video Verification',
                  query: {
                      redirect: 'video-verification-signup',
                    },
                });
              } else {
                setTimeout(() => {
                  if (this.skipBusinessProfileInReferral) {
                    this.getApprovals();
                  } else {
                    this.$router.push({ name: 'Pre Approval Step 3' });
                  }
                }, 1500);
              }
            } else if (response.data.subStatus === "businessInfoUpdated") {
              this.$router.push({ name: 'Pre Approval Review' });
            }
          }
        })
        .catch(err => {
          if (err.message === 'EPL-10000') {
            this.$router.push({ name: 'Pre Approval Step 2' });
            this.loading = false;
            this.resendOtpEnable = true;
            this.disableOtPAfterSubmit = false;
          } else {
            this.errorMessage = err.message;
            this.loading = false;
            this.resendOtpEnable = true;
            this.disableOtPAfterSubmit = false;
          }
        });
    },
    getApprovals() {
      this.$store.dispatch('applicationApprovals', {
        applicationId: this.applicationId,
        urlParams: { option: 'best' },
      }).then((result) => {
        this.loading = false;
         if (result.showApproval) {
          if (result.result[0]?.amountApproved > 0) {
          this.$router.push({
            name: 'Pre Approval Congratulations',
            query: {
              nextRoute: 'Pre Approval Review',
            }
          });
        } else if (result.result[0]?.amountApproved === 0 || result?.result[0]?.amountApproved === undefined) {
          this.$router.push({
            name: 'Pre Approval Review',
            params: {
              applicationId: this.applicationId,
            },
          });
        }
        } else {
          this.$router.push({ name: 'Pre Approval Step 3' });
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.border-dashed-custom {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23006295FF' stroke-width='4' stroke-dasharray='8%2c8' stroke-dashoffset='2' stroke-linecap='round'/%3e%3c/svg%3e");
}
.paddingBtn{
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.text_10px{
  font-size: 10px;
  padding-top: 2px;
}
.inputAadharCss_1{
  border-radius: 5px 0px 0px 5px;
  border-right: none;
}
.inputAadharCss_2{
  border-radius: 0px;
  border-right: none;
  border-left: none;
}
.inputAadharCss_3{
  border-radius: 0px;
  border-right: none;
  border-left: none;
}
.inputAadharCss_4{
  border-radius: 0px 5px 5px 0px;
  border-left: none;
}
</style>
